module.exports = __webpack_public_path__ + "static/macpro-7f47734fd7403f4cabed4030d015d404.mp4";